/// <amd-module name="Test/TestPlansLibrary/Pivots/TestCasesPivot/Redux/TestCasesReducer" />
import produce from "immer";

import { TestCasesActions, TestCasesActionTypes } from "./TestCasesActions";
import { ITestCasesPivotState } from "./TestCasesContracts";

export function TestCasesReducer(state: ITestCasesPivotState, action: TestCasesActions): ITestCasesPivotState {
    state = state || ({} as ITestCasesPivotState);

    return produce(state, (draftState: ITestCasesPivotState) => {
        switch (action.type) {
            case TestCasesActionTypes.clearTestCasesAndSetLoadingExperience:
                draftState.testCases = [];
                draftState.isLoading = true;
                break;

            case TestCasesActionTypes.loadInitialTestCasesSucceeded:
                draftState.isLoading = false;
                draftState.testCases = action.payload.testCases;
                draftState.workItemDataProviderState = action.payload.workItemDataProviderState;
                break;

            case TestCasesActionTypes.loadTestCasesPageSucceeded:
                draftState.isLoading = false;
                draftState.testCases = draftState.testCases.concat(action.payload.testCases);
                draftState.workItemDataProviderState = action.payload.workItemDataProviderState;
                break;

            case TestCasesActionTypes.updateProviderState:
                draftState.workItemDataProviderState = action.payload.newState;
                break;

            default:
                break;
        }
    });
}
